<template>
  <div class="alerts">
    <BModal ref="alert-details" size="xl" hide-footer hide-header>
      <div class="container">
        <AlertDetails :alert-data="alertDetails" />
      </div>
    </BModal>
    <div class="container">
      <div class="card">
        <h4>Lista de alertas</h4>
        <ul class="alerts__list">
          <li v-for="alert in alerts" :key="alert.id" class="alerts__list-item">
            <div class="alert__patient">
              <div class="alert__patient-avatar">
                <div
                  class="alert__patient-avatar-image"
                  :style="userPhoto(alert.user.photo)"
                />
                <Icon :name="'alert-icon'" :width="14" :height="14" />
              </div>
              <h6 class="alert__patient-name">{{ alert.user.name }}</h6>
            </div>
            <span class="alert__date">
              <i>
                Alerta emitido em {{ formattedAlertDate(alert.created_at) }}
              </i>
            </span>
            <button class="button4" @click="showModal(alert.id)">
              Exibir detalhes
            </button>
          </li>
        </ul>
      </div>
    </div>
    <Loading :active.sync="loading" :can-cancel="false" :is-full-page="true" />
  </div>
</template>

<script>
import { operatorMethods } from "./../state/helpers";
import { parseISO, format } from "date-fns";
import { pt as locale } from "date-fns/locale";
import AlertDetails from "../components/AlertDetails";
import Icon from "../components/CustomIcons";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  name: "Alerts",
  components: {
    AlertDetails,
    Icon,
    Loading
  },
  data() {
    return {
      alerts: [],
      alertDetails: null,
      loading: false
    };
  },
  async mounted() {
    await this.fetchAlerts().then(response => {
      this.alerts = response.data;
    });
    if (this.$route.params.showAlert) {
      showModal(this.$route.params.showAlert);
    }
  },
  methods: {
    ...operatorMethods,
    formattedAlertDate(alertDate) {
      const date = parseISO(alertDate);
      const formattedDate = format(date, "dd 'de' MMMM', ás 'HH:mm", {
        locale
      });
      return formattedDate;
    },
    async showModal(alertId) {
      (this.loading = true),
        await this.showAlert(alertId).then(response => {
          this.alertDetails = response.data;
          this.loading = false;
        });
      this.$refs["alert-details"].show();
    },
    userPhoto(photo) {
      return photo
        ? `background-image: url(${photo});`
        : `background-image: url(${require("./../assets/images/doctor-img.jpg")});`;
    }
  }
};
</script>
